import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseBlockAdded.meta';

export type UseTrackShowcaseBlockAddedParams = {
  page_name: string;
  type: 'image' | 'video' | 'links' | 'text';
};

export const useTrackShowcaseBlockAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseBlockAdded = useCallback(
    (params: UseTrackShowcaseBlockAddedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackShowcaseBlockAdded };
};
